import { buildQueryParams } from '../apiHelpers';
import { _request, APIBaseResponse, APIMethod } from '../index';

import { APIAclEntriesListParams, APIAclEntriesListResponse, APIAclEntryDeleteParams, APIAclEntryPostParams, APIAclEntryPutParams, GetAclWithProfileEntriesParams, GetAclWithProfileEntriesResponse } from './AclEntitiesApiTypeDefs';

const PROFILES_PATH_PREFIX = 'profiles';
const TENANTS_PATH_PREFIX = '/tenants';
const ACLS_PATH_PREFIX = 'acls';

export const APIAclEntriesGetList: APIMethod<APIAclEntriesListParams, APIAclEntriesListResponse> = (params: APIAclEntriesListParams) => {
    const queryParams = buildQueryParams(params);
    return _request('GET', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${ACLS_PATH_PREFIX}?${queryParams}`);
};

export const APIAclWithProfileEntriesGet: APIMethod<GetAclWithProfileEntriesParams, GetAclWithProfileEntriesResponse> = (params) => {
    const queryParams = buildQueryParams(params);
    return _request('GET', `/${PROFILES_PATH_PREFIX}${TENANTS_PATH_PREFIX}/${params.tenantId}/${ACLS_PATH_PREFIX}?${queryParams}`, undefined, params.signal, params.retries);
};

export const APIAclEntryPost: APIMethod<APIAclEntryPostParams, APIBaseResponse> = (params) => (
    _request<APIBaseResponse>(
        'POST',
        `${TENANTS_PATH_PREFIX}/${params.tenantId}/${ACLS_PATH_PREFIX}`,
        params)
);

export const APIAclEntryPut: APIMethod<APIAclEntryPutParams, APIBaseResponse> = (params) => (
    _request<APIBaseResponse>(
        'PUT',
        `${TENANTS_PATH_PREFIX}/${params.tenantId}/${ACLS_PATH_PREFIX}`,
        params)
);

export const APIAclEntryDelete: APIMethod<APIAclEntryDeleteParams, APIBaseResponse> = (params) => {
    const queryParams = buildQueryParams(params);
    return _request('DELETE', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${ACLS_PATH_PREFIX}?${queryParams}`);
};
